import { render, staticRenderFns } from "./markPdf.vue?vue&type=template&id=13991796&scoped=true"
import script from "./markPdf.vue?vue&type=script&lang=js"
export * from "./markPdf.vue?vue&type=script&lang=js"
import style0 from "./markPdf.vue?vue&type=style&index=0&id=13991796&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13991796",
  null
  
)

export default component.exports